import { Auth } from "aws-amplify";
import SignIn from "../pages/SignIn";
import ProcessDesigns from "../pages/ProcessDesigns";
import Onboard from "../pages/Onboard";
import Page404 from "../pages/Page404";
import Home from "../pages/Home";
import Impressum from "../pages/impressum";
import { createRouter, createWebHistory } from "vue-router";

const routes = [
  { path: "/signin", component: SignIn, meta: { auth: "public" } },
  { path: "/designs/:id?", component: ProcessDesigns, meta: { auth: "user" } },
  { path: "/onboard", component: Onboard },
  { path: "/impressum", component: Impressum },
  { path: "/home", component: Home },
  { path: "/", redirect: "/home" },
  { path: "/:pathMatch(.*)*", component: Page404 },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 1. navigate to /signin if the page requires auth,
// 2. or navigate to /designs if user wants to
//    navigate to /signin and s/he is already signed-in
router.beforeResolve(async (to, from, next) => {
  try {
    await Auth.currentAuthenticatedUser();
    if (to.meta?.auth == "public") next(from);
    else next();
  } catch (exp) {
    if (to.meta?.auth == "user") next({ path: "/signin" });
    else next();
  }
});

export default router;

export const navigateTo = (param) => {
  if (typeof param == "string") {
    param = { path: param };
  }

  if (router.currentRoute.path != param.path) {
    if (param.replace) router.replace(param);
    else router.push(param);
  }
};
